import { type PropsWithChildren } from 'react';
import styled from 'styled-components';

import { Modal } from '@soluto-private/aui-react-modal';
import { Button, Text } from '@soluto-private/mx-asurion-ui-react';

import { ReactComponent as CalendarSvg } from './assets/calendar.svg';

interface Props {
  dataTestId?: string;
  isOpen: boolean;
  onButtonClick: () => void;
  onCloseClick: () => unknown;
  primaryButtonLabel?: string;
  subtitle?: string;
  title: string;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Title = styled.h1`
  margin-top: 5px;
  text-align: center;
`;

const Subtitle = styled.h1`
  margin: 12px 0;
  text-align: center;
`;

const IconWrapper = styled.div`
  margin-top: 20px;
`;

export const NoAvailabilityModal = ({
  dataTestId,
  isOpen,
  onButtonClick,
  onCloseClick,
  primaryButtonLabel,
  subtitle,
  title,
}: PropsWithChildren<Props>) => {
  return (
    <Modal
      ariaLabel={title}
      data-testid={dataTestId}
      isOpen={isOpen}
      onCloseModal={() => onCloseClick()}
      style={{ maxWidth: '600px' }}
    >
      <Modal.Content>
        <Container>
          <IconWrapper>
            <CalendarSvg />
          </IconWrapper>

          <Title>
            <Text size={4} weight="feather">
              {title}
            </Text>
          </Title>
          <Subtitle>
            <Text size={2} weight="feather">
              {subtitle}
            </Text>
          </Subtitle>

          <Button
            autoFocus
            data-testid="PrimaryModalButton"
            onClick={() => onButtonClick()}
          >
            {primaryButtonLabel}
          </Button>
        </Container>
      </Modal.Content>
    </Modal>
  );
};
